import React, { Fragment } from 'react'
import SearchInput from 'components/SearchInput'

const TableSearch = ({ TheadComponent, isSearching, onSearch, ...props }) => {
	const { className, children } = props
	const style = {
		...props.style,
		order: -1
	}
	return (
		<Fragment>
			{TheadComponent ?
				<TheadComponent {...props} style={style}/> :
				<div className={`rt-thead ${className}`} style={style}>
					{children}
				</div>
			}
			<div className={`rt-thead ${className}`} style={style}>
				<SearchInput
					isInTable={true}
					style={{
						zIndex: isSearching ? 2 : 0		// show searchbar over 'no data' block if there is something in searchbar
					}}
					onSearch={onSearch}/>
			</div>
		</Fragment>
	)
}

export default TableSearch
